/**
 * HEAREN — MiniPlayer
 * 
 * Global persistent mini player bar.
 * Appears above TabBar when audio is playing in background.
 * Tap → navigate back to full player.
 */
import { nativeAudioPlayer } from '@/native/nativeAudio/nativeAudioPlayer';
import { getSessionStopHandler } from '@/services/sessionStopRegistry';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, Pause, X } from 'lucide-react';
import { useNowPlaying } from '@/contexts/NowPlayingContext';

const MiniPlayer = () => {
  const navigate = useNavigate();
  const { nowPlaying, setTrack: setNowPlaying, togglePlayPause, stopAndClear } = useNowPlaying();
  console.log('[MiniPlayer DEBUG]', {
    nowPlaying,
    path: window.location.pathname,
  });

  if (!nowPlaying || !nowPlaying.title) return null;

  const handleTap = () => {
    // V1.2 FIX: Pass resume flag + playerState so TherapyPlayer restores the active session
    navigate(`/therapy?theme=${nowPlaying.theme || ''}&resume=1&autoplay=0`, {
  replace: true,
  state: {
    resumeFromMiniPlayer: true,
    playerState: {
      ...nowPlaying.playerState,
      selectedSound: nowPlaying.playerState?.selectedSound,
      selectedStyle: nowPlaying.playerState?.selectedStyle || nowPlaying.theme,
      isPlaying: nowPlaying.isPlaying,
    },
    keepAudioAlive: true,
  }
});
  };

  return (
    <div
      className="fixed left-0 right-0 z-40 px-3"
      style={{ bottom: 'calc(84px + env(safe-area-inset-bottom, 0px))' }}
      data-testid="mini-player"
    >
      <div
        className="flex items-center gap-3 rounded-2xl px-4 py-2.5 backdrop-blur-xl"
        style={{
          background: 'rgba(15,10,30,0.88)',
          border: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 -4px 24px rgba(0,0,0,0.4)',
        }}
      >
        {/* Accent bar */}
        <div className="w-1 h-8 rounded-full" style={{ background: nowPlaying.accent || 'rgba(139,92,246,0.5)' }} />

        {/* Track info — tappable */}
        <button onClick={handleTap} className="flex-1 min-w-0 text-left">
          <p className="text-white text-sm font-medium truncate" data-testid="mini-player-title">
            {nowPlaying.title || 'Playing'}
          </p>
          <p className="text-white/40 text-xs truncate">
            {nowPlaying.themeLabel || nowPlaying.theme || ''}
          </p>
        </button>

        {/* Play/Pause */}
        <button
          onClick={async (e) => {
  e.stopPropagation();

  const state = nativeAudioPlayer.getState();

  console.log('[MiniPlayer][II DEBUG]', {
    nowPlaying,
    nativeState: state,
  });

  try {
    if (state.isLoaded && state.isPlaying) {
      await nativeAudioPlayer.pause();

      setNowPlaying({
        isPlaying: false,
      });

      console.log('[MiniPlayer][NativeAudio] paused');
      return;
    }

    if (state.isLoaded && !state.isPlaying) {
      await nativeAudioPlayer.play();

      setNowPlaying({
        isPlaying: true,
      });

      console.log('[MiniPlayer][NativeAudio] resumed');
      return;
    }

    console.warn('[MiniPlayer][NativeAudio] not loaded, fallback toggle');
    togglePlayPause();
  } catch (err) {
    console.error('[MiniPlayer][NativeAudio] toggle failed', err);
  }
}}
          className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 active:scale-90 transition-transform"
          style={{ background: 'rgba(139,92,246,0.25)' }}
          data-testid="mini-player-toggle"
        >
          {nowPlaying.isPlaying ? (
            <Pause size={15} className="text-purple-300" fill="currentColor" />
          ) : (
            <Play size={15} className="text-purple-300 ml-0.5" fill="currentColor" />
          )}
        </button>

        {/* Stop / Close */}
<button
onClick={async (e) => {
  e.stopPropagation();

  console.log('[MINI PLAYER X TEST] clicked');

  try {
    await nativeAudioPlayer.stop();
    console.log('[MINI PLAYER X TEST] native stop OK');
  } catch (err) {
    console.error('[MINI PLAYER X TEST] native stop failed', err);
  }

  try {
    stopAndClear();
    console.log('[MINI PLAYER X TEST] stopAndClear OK');
  } catch (err) {
    console.error('[MINI PLAYER X TEST] stopAndClear failed', err);
  }

  try {
    setNowPlaying(null);
    console.log('[MINI PLAYER X TEST] setNowPlaying null OK');
  } catch (err) {
    console.error('[MINI PLAYER X TEST] setNowPlaying null failed', err);
  }
}}
  className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 active:scale-90 transition-transform"
  style={{ background: 'rgba(255,255,255,0.06)' }}
  data-testid="mini-player-close"
>
  <X size={13} className="text-white/40" />
</button>
      </div>
    </div>
  );
};

export default MiniPlayer;
